import { Get, Put } from "api";
import { getPartners } from "views/admin/partners/services";
import { Partner } from "redux/partners/reducer";
import {
  ExclusionScope,
  OwnApp,
  PartnerAppExclusion,
  PartnerGame,
} from "views/admin/appTargeting/types";

export interface PartnerDetails {
  companyName: string;
  games: PartnerGame[];
}

export async function getOwnApps(): Promise<OwnApp[]> {
  const response = await Get("/manage/own-apps");

  return Array.isArray(response) ? response : [];
}

export async function getAllPartnerAppExclusions(): Promise<
  PartnerAppExclusion[]
> {
  const response = await Get("/manage/partner-app-exclusions");

  return Array.isArray(response) ? response : [];
}

export async function getPartnersWithCampaigns(): Promise<Partner[]> {
  const response = await getPartners({
    page: 1,
    pageSize: 1000,
    filters: { hasAtLeastOneCampaign: true },
  });

  return response?.data ?? [];
}

// The partner detail endpoint lists the partner's games with the identifier the backend
// uses per platform (package name on Android, store id on iOS).
export async function getPartnerDetails(
  partnerId: number
): Promise<PartnerDetails> {
  const response = await Get(`/manage/partners/${partnerId}`);

  return {
    companyName: response?.companyName ?? "",
    games: Array.isArray(response?.apps) ? response.apps : [],
  };
}

export async function getPartnerAppExclusions(
  partnerId: number
): Promise<PartnerAppExclusion[]> {
  const response = await Get(`/manage/partners/${partnerId}/app-exclusions`);

  return Array.isArray(response) ? response : [];
}

// Replaces the partner's whole matrix: a scope that is not listed ends up with no rows.
export async function replacePartnerAppExclusions(
  partnerId: number,
  scopes: ExclusionScope[]
): Promise<PartnerAppExclusion[]> {
  const response = await Put(`/manage/partners/${partnerId}/app-exclusions`, {
    scopes,
  });

  if (response?.error) {
    throw new Error(response.error);
  }

  if (!Array.isArray(response)) {
    throw new Error("Save failed");
  }

  return response;
}
